import { ClickAwayListener } from '@material-ui/core'

import Autocomplete from './Autocomplete'
import { AwesomeBarContextProvider, useAwesomeBarContext } from './AwesomeBarContext'
import FocusDropdown, { FocusDropdownTitle } from './FocusDropdown'
import { IAwesomeBarProps } from './types'

const AwesomeBarWrapper = (props: IAwesomeBarProps) => {
  return (
    <AwesomeBarContextProvider {...props}>
      <AwesomeBar />
    </AwesomeBarContextProvider>
  )
}

const AwesomeBar = () => {
  const { onBlurInput } = useAwesomeBarContext()
  return (
    <ClickAwayListener onClickAway={onBlurInput}>
      <div>
        <Autocomplete />
        <FocusDropdown />
      </div>
    </ClickAwayListener>
  )
}

export default AwesomeBarWrapper
export * as types from './types'
export { FocusDropdownTitle }
